import { reactive } from 'vue';

export const store = reactive({
  isUpdate: false,
  dataFetching: {
    produtos: true,
    servicos: true,
  },
});
